<template>
  <div
    id="ticket-update-item-container"
    class="w-full pl-5"
  >

    <div
      class="w-full relative pl-10 sm:pl-16 pb-4 border-l border-gray-200"
      :class="last ? 'border-dashed' : 'border-solid'"
    >

      <div
        id="status-icon"
        class="absolute -left-7.2 -top-3 p-2.5 text-center align-middle rounded-full bg-white">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          class="h-10 w-10 rounded-full p-1.5 text-center align-middle bg-gray-400 text-white"
          viewBox="0 0 20 20"
          fill="currentColor"
        >
          <path
            d="M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884z"
          />
          <path
            d="M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z"
          />
        </svg>
      </div>

      <div
        id="ticket-detail-customer"
        v-if="history.type === 'task' && history.status === 'awaiting_customer'"
        class="w-full flex flex-col justify-start items-start text-gray-800"
      >
        <div class="flex flex-row justify-start items-center">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="h-4 w-4 text-gray-500 -ml-px relative -top-px"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
            />
          </svg>
          <span class="font-medium ml-2">{{ history.date | formatDate }}</span>
        </div>
        <div class="font-medium mt-1">
          {{ history.title }}
        </div>
        <p
          class="mt-6"
          v-html="history.body"
        />
        <button
          id="ticket-detail-customer-go-to-task"
          class="w-full sm:w-auto py-3 px-8 mt-4 font-medium text-white bg-purple-800 hover:bg-purple-700 active:bg-purple-900 disabled:bg-purple-organization disabled:opacity-50 transition-all rounded shadow"
          @click="goToTaskDetail(history.link)"
        >
          Clique aqui para preencher
        </button>
      </div>

      <div
        id="ticket-detail-task-done"
        v-if="history.type === 'task' && history.status === 'done'"
        class="w-full flex flex-col justify-start items-start text-gray-800"
      >
        <div class="flex flex-row justify-start items-center">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="h-4 w-4 text-gray-500 -ml-px relative -top-px"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
            />
          </svg>
          <span class="font-medium ml-2">{{ history.date | formatDate }}</span>
        </div>
        <div class="font-medium">
          {{ history.title }}
        </div>
        <p
          class="mt-6"
          v-html="history.body"
        />
        <p class="w-full flex flex-row justify-start items-center mt-2 text-green-organization">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="h-5 w-5"
            fill="none"
            viewBox="0 0 24 24" stroke="currentColor"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2" d="M5 13l4 4L19 7"
            />
          </svg>
          <span
            class="ml-2"
          >
            {{ getMessageDoneTask(history) }}
          </span>
        </p>
      </div>

      <div
        id="ticket-detail-email"
        v-if="history.type === 'email'"
        class="w-full flex flex-col justify-start items-start text-gray-800"
      >
        <div class="flex flex-row justify-start items-center">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="h-4 w-4 text-gray-500 -ml-px relative -top-px"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
            />
          </svg>
          <span class="font-medium ml-2">{{ history.date | formatDate }}</span>
        </div>
        <div class="font-medium">
          {{ history.title }}
        </div>
        <p
          class="mt-6"
          v-html="textCount"
        />
        <p
          v-if="!showFullTextFlag"
          class="mt-2 text-sm text-purple-organization hover:text-purple-organization-light active:text-purple-organization-dark cursor-pointer"
          @click="showFullText"
        >
          Ler mais
        </p>
        <p
          v-if="showFullTextFlag"
          class="mt-2 text-sm text-purple-organization hover:text-purple-organization-light active:text-purple-organization-dark cursor-pointer"
          @click="showFullText"
        >
          Ler menos
        </p>
      </div>
    </div>

    <div
      id="history-separator"
      class="w-full h-4 border-b border-gray-200"
    />
    <br/>
  </div>
</template>

<script>
import dayjs from 'dayjs'
import 'dayjs/locale/pt-br'

export default {
  name: 'ExternalOrderItem',
  props: {
    history: Object,
    last: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      showFullTextFlag: false
    }
  },
  filters: {
    formatDate: value => (!value ? null : dayjs(value).format('DD/MM/YYYY - HH:mm'))
  },
  computed: {
    textCount () {
      if (this.showFullTextFlag) {
        return this.history.body
      }

      const textAsArray = this.history.body.split('')

      if (textAsArray.length <= 150) return this.history.body

      let slicedText = textAsArray.slice(0, 147)
        .join('')

      slicedText = slicedText + '...'

      return slicedText
    }
  },
  methods: {
    goToTaskDetail (link) {
      this.$router.push(link)
    },
    showFullText () {
      this.showFullTextFlag = !this.showFullTextFlag
    },
    getMessageDoneTask (history) {
      if (history.answeredBy === 'mobly') {
        return `Informações já preenchidas pelo nosso super time em ${dayjs(history.date).format('DD/MM/YYYY')}`
      }

      return `Informações já preenchidas por ${history.client} em ${dayjs(history.date).format('DD/MM/YYYY')}`
    }
  }
}
</script>
